<template>
  <div @click="toggleExpand()" class="w-full relative flex justify-center items-center group">
    <div ref="cardEl" :class="[expand ? 'bg-woodsmoke-850 border-y border-y-white/50' : 'border-b border-b-white/10', currentFocus ? (currentFocus != entry.project.project_id ? 'opacity-20' : '') : '']" class="w-full grid grid-cols-8 justify-center items-center lg:hover:bg-white/5 cursor-pointer relative">
      <div v-if="entry.claimable" class="lg:hidden col-span-full px-4 pt-4 text-turquoise-500 text-sm animate-pulse">Claims Available</div>

      <div class="flex justify-start items-center space-x-4 w-full lg:col-span-2 col-span-7 lg:p-4 pl-4">
        <div class="bg-white/10 w-10 h-10 flex-shrink-0 rounded-md overflow-hidden border border-white/20">
          <img class="w-full h-full object-cover" :src="entry.project.project_logo" />
        </div>
        <div>
          <p class="text-white lg:text-xl">{{ entry.project.project_name }}</p>

          <div class="flex justify-start items-center flex-wrap gap-1">
            <p class="text-woodsmoke-200 text-sm">contributed</p>
            <p class="text-woodsmoke-50 text-sm">{{ Math.floor(Number(entry.total_effective_contribution) * 100) / 100 }} {{ entry.contribution_symbol }}</p>
          </div>
        </div>
      </div>

      <div class="w-full flex lg:hidden justify-end items-center p-4 space-x-2">
        <div class="dropdown dropdown-end">
          <!-- <div tabindex="0" role="button" class="btn m-1">Click</div> -->

          <button @click.stop role="button" class="btn min-h-0 p-2 border-none m-0 h-auto bg-white/10">
            <Icon name="material-symbols:more-vert" class="text-white" />
          </button>

          <ul tabindex="0" class="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-md translate-y-2 w-52 border border-white/20">
            <NuxtLink :to="`/app/project/${entry.project.project_id}?tab=vesting`">
              <li>
                <a>Go to {{ entry.project.project_name }}</a>
              </li>
            </NuxtLink>
            <!-- <li><a>Item 2</a></li> -->
          </ul>
        </div>

        <button @click.stop="toggleExpand()" :class="[entry.claimable ? (expand ? 'bg-turquoise-500 text-turquoise-1000 lg:hover:text-white' : 'border-white/20 text-turquoise-1000 bg-turquoise-500') : expand ? 'bg-turquoise-500 text-turquoise-1000 lg:hover:text-white' : 'border-white/20 text-white bg-white/10']" class="btn min-h-0 p-2 px-3 m-0 h-auto border hover:text-white">{{ expand ? "Minimize" : "Expand" }}</button>
      </div>

      <div class="w-full col-span-full lg:col-span-3 grid grid-cols-4 items-center px-4 mb-2">
        <p class="text-woodsmoke-300 col-span-3 text-sm">claimed</p>

        <div class="w-full flex justify-end items-center space-x-2">
          <div class="w-24 flex-shrink-0 h-2 bg-white/10 flex justify-start items-center rounded-full overflow-hidden border border-white/20">
            <div class="h-2 bg-turquoise-500" :style="`width:${entry.total_claimed_progress > 0 ? entry.total_claimed_progress : 0}%;`"></div>
          </div>
          <div class="w-16 text-right flex text-sm flex-shrink-0">{{ Math.floor(Number(entry.total_claimed_progress) * 100) / 100 }} %</div>
        </div>

        <div class="col-span-full w-full flex justify-between items-center">
          <p class="text-woodsmoke-50">{{ Math.floor(Number(entry.total_claimed_token) * 100) / 100 }} {{ entry.symbol }}</p>
          <p>/ {{ Math.floor(Number(entry.total_claimable_token) * 100) / 100 }} {{ entry.symbol }}</p>
        </div>
      </div>

      <div class="w-full lg:hidden flex justify-start items-center px-4 space-x-4 mb-4">
        <p class="text-woodsmoke-300 col-span-3 text-sm">frequency</p>

        <div class="w-full">
          {{ uniqueFrequencies }}
        </div>
      </div>

      <div class="w-full hidden lg:flex justify-between items-center space-x-4 col-span-3 p-4">
        <div>
          <p class="text-sm text-woodsmoke-300">frequency</p>
          <p>{{ uniqueFrequencies }}</p>
        </div>

        <div class="flex justify-end items-center space-x-2">
          <div v-if="entry.claimable" class="text-sm text-turquoise-500 break-words animate-pulse">Claims Available</div>

          <div class="dropdown dropdown-end">
            <!-- <div tabindex="0" role="button" class="btn m-1">Click</div> -->

            <button @click.stop role="button" class="btn min-h-0 p-2 border-none m-0 h-auto bg-white/10">
              <Icon name="material-symbols:more-vert" class="text-white" />
            </button>

            <ul tabindex="0" class="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-md translate-y-2 w-52 border border-white/20">
              <NuxtLink :to="`/app/project/${entry.project.project_id}?tab=vesting`">
                <li>
                  <a>Go to {{ entry.project.project_name }}</a>
                </li>
              </NuxtLink>
              <!-- <li><a>Item 2</a></li> -->
            </ul>
          </div>

          <button @click.stop="toggleExpand()" :class="[entry.claimable ? (expand ? 'bg-turquoise-500 text-turquoise-1000 lg:hover:text-white' : 'border-white/20 text-turquoise-1000 bg-turquoise-500') : expand ? 'bg-turquoise-500 text-turquoise-1000 lg:hover:text-white' : 'border-white/20 text-white bg-white/10']" class="btn min-h-0 p-2 px-3 m-0 h-auto border hover:text-white">{{ expand ? "Minimize" : "Expand" }}</button>
        </div>
      </div>

      <div class="w-full col-span-full lg:block hidden" v-if="expand">
        <div class="w-full grid grid-cols-9 text-xs uppercase tracking-widest text-white text-center px-4 py-2 bg-white/5 gap-2 justify-center items-center">

          <div class="flex col-span-2">
            <input @click.stop="addProjectToMultiClaim()" :checked="isAllProjectVestingAdded" v-if="isAtLeastOneMultiClaim" type="checkbox" class="w-4 h-4 text-turquoise-600 bg-gray-100 border-gray-300 rounded focus:ring-turquoise-500 dark:focus:ring-turquoise-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <input disabled="true" v-else type="checkbox" class="w-4 h-4 text-gray-600 bg-gray-900 border-gray-900 rounded focus:ring-gray-900 dark:focus:ring-gray-600 dark:ring-gray-800 focus:ring-2 dark:bg-gray-900 dark:border-gray-900">
            <p class="text-left pl-2">Title</p>
          </div>

          <p class="text-left">Schedule</p>
          <p>Available</p>
          <p>Claimed</p>
          <p>Total</p>
          <p class="text-right">Network</p>

          <div></div>
        </div>

        <div v-for="_claim in vestingRows" class="w-full border-b border-b-white/10 grid grid-cols-9 text-woodsmoke-50 text-center last:mb-0 last:border-b-0 p-4 lg:hover:bg-white/10 gap-2 justify-center items-center">
          
          <div class="flex items-center col-span-2">
            <input @click.stop="addToMultiClaim(_claim)" :checked="multiClaimList.map(x => x.contract_address).includes(_claim.contract_address)" v-if="_claim.chainId == chainId && _claim?.has_multicall && _claim.available_amount > 0" type="checkbox" class="w-4 h-4 text-turquoise-600 bg-gray-100 border-gray-300 rounded focus:ring-turquoise-500 dark:focus:ring-turquoise-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <input disabled="true" v-else type="checkbox" class="w-4 h-4 text-gray-600 bg-gray-900 border-gray-900 rounded focus:ring-gray-900 dark:focus:ring-gray-600 dark:ring-gray-800 focus:ring-2 dark:bg-gray-900 dark:border-gray-900">
            <p class="pl-2 text-left">{{ _claim.topic }}</p>
          </div>

          <div class="w-full text-left flex justify-start space-x-2 items-center">
            <div>
              {{ _claim.schedule_type }}
            </div>

            <button v-if="_claim.schedule_type != 'once' && _claim.schedule?.length > 0" @click.stop="viewSchedule(_claim.schedule, _claim.topic)" class="btn btn-link m-0 p-0 h-auto btn-xs text-turquoise-500 animate-pulse">view</button>
          </div>

          <div class="flex w-full justify-start items-center">
            <p class="text-center w-full" v-if="_claim.available_amount >= 0">{{ Math.floor(Number(_claim.available_amount) * 100) / 100 }} {{ _claim.symbol }}</p>
            <div v-else class="h-6 w-20 skeleton rounded-md"></div>
          </div>

          <p>{{ Math.floor(Number(_claim.claimed_amount) * 100) / 100 }} {{ _claim.symbol }}</p>

          <p>{{ Math.floor(Number(_claim.total_claimable_amount) * 100) / 100 }} {{ _claim.symbol }}</p>

          <div class="text-right">{{ _claim.network }}</div>

          <div class="w-full flex justify-end items-center space-x-2 col-span-2">
            <button @click.stop="showRefundModal()" v-if="_claim.can_refund" class="btn btn-link min-h-0 h-auto text-red-400 p-0 m-0 mr-4">Refund</button>

            <button :disabled="_claim.available_amount == 0" @click.stop="claimButton(_claim)" v-if="_claim.chainId == chainId" class="btn btn-link min-h-0 h-auto text-turquoise-500 p-0 m-0">Claim</button>
            <!-- <button :disabled="(_claim.available_amount == 0) || (multiClaimList.map(x => x.contract_address).includes(_claim.contract_address))" @click.stop="addToMultiClaim(_claim)" v-if="_claim.chainId == chainId && _claim?.has_multicall" class="btn btn-lg min-h-0 h-auto text-turquoise-500 p-2 m-0">+</button> -->
            

            <button @click="switchToVestingNetwork(_claim.chainId)" v-if="_claim.chainId != chainId" class="btn btn-link min-h-0 h-auto text-turquoise-500 p-0 m-0">Switch Network</button>
            <a @click.stop v-if="_claim.explorer_url" :href="_claim.explorer_url" target="_blank" class="btn btn-link min-h-0 h-auto text-turquoise-500 p-0 m-0">[View Tx]</a>
          </div>
        </div>
      </div>

      <div v-if="expand" class="pt-2 border-t border-t-white/10 w-full col-span-full lg:hidden">
        <div v-for="_claim in vestingRows" class="w-full grid grid-cols-6 p-4 border-b border-b-white/10 last:mb-0 last:border-b-0">
          <div class="col-span-3">
            <input @click.stop="addToMultiClaim(_claim)" :checked="multiClaimList.map(x => x.contract_address).includes(_claim.contract_address)" v-if="_claim.chainId == chainId && _claim?.has_multicall && _claim.available_amount > 0" type="checkbox" class="w-4 h-4 text-turquoise-600 bg-gray-100 border-gray-300 rounded focus:ring-turquoise-500 dark:focus:ring-turquoise-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
            <input disabled="true" v-else type="checkbox" class="w-4 h-4 text-gray-600 bg-gray-900 border-gray-900 rounded focus:ring-gray-900 dark:focus:ring-gray-600 dark:ring-gray-800 focus:ring-2 dark:bg-gray-900 dark:border-gray-900">
            <p class="text-xl text-white">{{ _claim.topic }}</p>
          </div>

          <div class="col-span-3 text-right flex flex-col justify-end items-end">
            <p class="text-sm">Available</p>
            <p v-if="_claim.available_amount >= 0" class="text-white">{{ Math.floor(Number(_claim.available_amount) * 100) / 100 }} {{ _claim.symbol }}</p>
            <div v-else class="h-6 w-20 skeleton rounded-md"></div>
          </div>

          <div class="flex justify-start items-center space-x-2 col-span-full">
            <p>Schedule: {{ _claim.schedule_type }}</p>
            <button @click="viewSchedule(_claim.schedule, _claim.topic)" class="btn bg-white/10 btn-xs text-turquoise-500 border-none">View</button>
          </div>

          <div class="col-span-4 pt-4">
            <div class="flex justify-start items-center text-sm space-x-4">
              <p class="">Claimed</p>
              <p class="text-white">{{ Math.floor(Number(_claim.claimed_amount) * 100) / 100 }} {{ _claim.symbol }}</p>
            </div>

            <div class="flex justify-start items-center text-sm space-x-4">
              <p class="">Total to Claim</p>
              <p class="text-white">{{ Math.floor(Number(_claim.total_claimable_amount) * 100) / 100 }} {{ _claim.symbol }}</p>
            </div>

            <div class="flex justify-start items-center text-sm space-x-4">
              <p class="">Network</p>
              <p class="text-white">{{ _claim.network }}</p>
            </div>
          </div>

          <div class="w-full flex justify-end items-center col-span-2">
            <!-- <button @click.stop="showRefundModal()" v-if="_claim.can_refund" class="btn btn-link min-h-0 h-auto text-red-400 p-0 m-0 mr-4">Refund</button> -->

            <button v-if="_claim.can_refund" @click.stop="showRefundModal()" class="btn btn-sm bg-white/10 text-red-400 border-none mr-2">Refund</button>

            <button :disabled="_claim.available_amount == 0" @click="claimButton(_claim)" v-if="_claim.chainId == chainId" class="btn btn-sm bg-white/10 text-turquoise-500 border-none">Claim</button>
            <button @click="switchToVestingNetwork(_claim.chainId)" v-if="_claim.chainId != chainId" class="btn btn-sm bg-white/10 text-turquoise-500 border-none">Switch Network</button>
          </div>

          <!-- <div class="col-span-2 pt-4">
            <p class="text-sm">Total to Claim</p>
            <p>123456789 USDT</p>
          </div>
  
          <div class="col-span-2 pt-4">
            <p class="text-sm">Progress</p>
            <p>50%</p>
          </div> -->
        </div>
      </div>
    </div>

    <div v-if="!expand && currentFocus" class="w-full h-full absolute flex justify-center items-center scale-0 group-hover:scale-100 duration-200">
      <div class="bg-black p-1 px-2 rounded-sm text-turquoise-500 cursor-pointer">Tap to view {{ entry.project.project_name }} claims</div>
    </div>

    <HeadlessTransitionRoot as="template" :show="isShowRefundModal">
      <HeadlessDialog as="div" class="relative z-[999]" @close="isShowRefundModal = false">
        <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </HeadlessTransitionChild>

        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-850 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <h1 class="text-lg text-white mb-4 px-2">
                    Refund for
                    <span class="underline">{{ entry.project.project_name }}</span>
                  </h1>

                  <div class="w-full bg-white/5 p-4 rounded-md">
                    <p class="text-white mb-8">Recover your effective contribution via refund.</p>

                    <p class="leading-6">
                      If you have
                      <span class="text-turquoise-500">previously claimed ${{ entry.symbol }}</span>
                      , you must ensure the
                      <span class="text-turquoise-500">exact amount of ${{ entry.symbol }} is present in your wallet</span>
                      . The specified
                      <span class="text-turquoise-500">${{ entry.symbol }} amount will be deducted</span>
                      from your wallet at the time of the refund.
                    </p>
                  </div>
                </div>

                <div class="p-4 text-center animate-pulse">
                  <p class="text-white">Please refund from claim section of project page.</p>
                </div>
                <div class="flex justify-between items-center">
                  <button @click="isShowRefundModal = false" class="btn btn-link text-turquoise-500">Back</button>
                  <NuxtLink :to="`/app/project/${entry.project.project_id}?tab=vesting`">
                    <button type="button" class="inline-flex justify-center rounded-md bg-turquoise-500 px-3 py-2 text-sm font-semibold shadow-sm hover:bg-turquoise-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-turquoise-600 text-turquoise-900">Continue to refund in Project Page</button>
                  </NuxtLink>
                </div>
              </HeadlessDialogPanel>
            </HeadlessTransitionChild>
          </div>
        </div>
      </HeadlessDialog>
    </HeadlessTransitionRoot>
  </div>
</template>

<script setup>
const expand = ref(false);

const cardEl = ref(null);

const emit = defineEmits(["focus", "schedule", "multiclaim"]);

import { formatUnits, parseEther } from "viem";
import * as ethers from "ethers";
// import { $wagmiConfig } from "~/wagmiConfig.js";
const { $address } = useNuxtApp();

const props = defineProps(["id", "currentFocus", "entry", "chainId", "address"]);
const { id, currentFocus, entry, chainId, address } = toRefs(props);

import { switchChain, getBalance, waitForTransactionReceipt, writeContract, readContract } from "@wagmi/core";

import { useUserStore } from "~/stores/user.js";
const userStore = useUserStore();

const toast = useToast();

const _toast = (param) => {
  toast.add({
    ...param,
    ui: {
      strategy: "override",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mt-0.5",
        color: "text-{color}-500 dark:text-{color}-400",
      },
      background: "bg-woodsmoke-800/50 backdrop-blur-md",
      container: "border border-turquoise-500/20 relative overflow-hidden",
      title: "text-turquoise-500 text-base",
      description: "text-white text-sm",
    },
  });
};

const { $wagmiConfig, $multiCallContract } = useNuxtApp();

const vestings = ref();

const updateVesting = async () => {
  vestings.value = new Map();

  // loop the entry.vestings, use entry.vestings.whitelist.vesting_ca as key

  for (let i = 0; i < entry.value.vestings?.length; i++) {
    let _vesting = entry.value.vestings[i];
    // get the claimable amount

    // await getVestingProjectClaimableAmount(_vesting.whitelist.vesting_ca);

    // set the claimable amount to the vestings map

    let txHash = _vesting.activities.length > 0 ? _vesting.activities?.at(0).transactionHash : null;

    vestings.value.set(_vesting.whitelist.vesting_ca, {
      claimable: _vesting.claimable,
      available_amount: -1,
      claimed_amount: _vesting.claimed_amount,
      decimal: _vesting.pool.decimal,
      topic: _vesting.pool.claim_title,
      schedule_type: _vesting.schedule_type,
      total_claimable_amount: _vesting.total_claimable_amount,
      symbol: entry.value.symbol,
      network: getNetworkName(_vesting.pool.chain),
      chainId: _vesting.pool.chain,
      has_fee: _vesting.pool.has_fee,
      contract_address: _vesting.whitelist.vesting_ca,
      schedule: _vesting.schedule,
      can_refund: _vesting.pool.refund,
      transactionHash: txHash,
      has_merkletree: _vesting.pool.has_merkletree,
      has_multicall: _vesting.pool.has_multicall,
      explorer_url: txHash ? `${getExplorer(_vesting.pool.chain)}/tx/${txHash}` : null,
      whitelist: _vesting.whitelist,
    });
  }

  pullAmountIfExpanded();
};

const getNetworkName = (id) => {
  switch (id) {
    case 56:
      return "BSC";
    case 137:
      return "Polygon";
    case 1:
      return "ETH";
    case 42161:
      return "Aribitrum One";
    case 8453:
      return "Base Mainnet";
    default:
      return "Unknown";
  }
};

const getExplorer = (id) => {
  switch (id) {
    case 56:
      return "https://bscscan.com";
    case 137:
      return "https://polygonscan.com";
    case 1:
      return "https://etherscan.io";
    case 42161:
      return "https://arbiscan.io";
    case 8453:
      return "https://basescan.org";
    default:
      return "https://etherscan.io";
  }
};

const pullAmountIfExpanded = async () => {
  if (expand.value) {
    //   // loop the vestings map, get the claimable amount

    for (let [key, value] of vestings.value) {
      // console.log("-----",key,value)

      // let _result = await getVestingProjectClaimableAmount(key, value.chainId);

      // console.log(vestings.value, key, value);
      let result = null;
      if(value?.has_merkletree) {

        result = await readContract($wagmiConfig, {
          abi: [{ "inputs": [ { "internalType": "address", "name": "_account", "type": "address" }, { "internalType": "uint256", "name": "_allocation", "type": "uint256" }, { "internalType": "uint256", "name": "_refund", "type": "uint256" }, { "internalType": "bytes32[]", "name": "_merkleProof", "type": "bytes32[]" } ], "name": "claimAmount", "outputs": [ { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "stateMutability": "view", "type": "function" }],
          address: value.contract_address,
          functionName: "claimAmount",
          args: [address.value, value.whitelist.token_claimable_amount, value.whitelist.stable_refundable_amount, JSON.parse(value.whitelist.leaf)],
          chainId: value.chainId,
        });
        // console.log('result', result)

      } else {

        result = await readContract($wagmiConfig, {
          abi: [ { inputs: [ { internalType: "address", name: "_account", type: "address", }, ], name: "claimAmount", outputs: [ { internalType: "uint256", name: "_amount", type: "uint256", }, ], stateMutability: "view", type: "function", }, ],
          address: value.contract_address,
          functionName: "claimAmount",
          args: [address.value],
          chainId: value.chainId,
        });

      }

      // let abi = [
      //   {
      //     inputs: [
      //       {
      //         internalType: "address",
      //         name: "_account",
      //         type: "address",
      //       },
      //     ],
      //     name: "claimAmount",
      //     outputs: [
      //       {
      //         internalType: "uint256",
      //         name: "_amount",
      //         type: "uint256",
      //       },
      //     ],
      //     stateMutability: "view",
      //     type: "function",
      //   },
      // ];

      // const result = await readContract($wagmiConfig, {
      //   abi,
      //   address: value.contract_address,
      //   functionName: "claimAmount",
      //   args: [address.value],
      //   chainId: value.chainId,
      // });

      // console.log(address.value, result)

      //       // set the claimable amount to the vestings map

      //       // console.log("pull result",_result)

      vestings.value.set(key, {
        ...value,
        available_amount: Number(formatUnits(result, value.decimal)),
      });

      // vestings.value.set(key, _result);
    }

    // console.log("-----", vestings.value);
  }
};

const scrollCard = () => {
  setTimeout(() => {
    // get the top position of the card

    try {
      const top = cardEl.value.getBoundingClientRect().top;

      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    } catch (err) {}

    // scroll to the top of the card
  }, 300);
};

const toggleExpand = () => {
  expand.value = !expand.value;

  if (expand.value) {
    emit("focus", entry.value.project.project_id);
  } else {
    emit("focus", null);
  }

  scrollCard();
  updateVesting();
};

const viewSchedule = (_dates, _topic) => {
  emit("schedule", {
    dates: _dates,
    topic: _topic,
  });
};

import { queryNoCache } from "~/apollo";
import { gql } from "@apollo/client/core";

const getVestingProjectClaimableAmount = (_ca, _chainId) => {
  return new Promise(async (resolve) => {
    let gqlResult = await queryNoCache(
      gql`
        query Query($chain: Int, $contractAddress: String) {
          getVestingProjectClaimableAmount(chain: $chain, contract_address: $contractAddress)
        }
      `,
      {
        chain: _chainId,
        contractAddress: _ca,
      }
    );

    // console.log('gqlResult', gqlResult);
    resolve(gqlResult["getVestingProjectClaimableAmount"]);
  });
};

const vestingRows = computed(() => {
  return Array.from(vestings.value.values());
});

const uniqueFrequencies = computed(() => {
  let _frequencies = new Set();

  for (let i = 0; i < entry.value.vestings.length; i++) {
    _frequencies.add(entry.value.vestings[i].schedule_type);
  }

  return Array.from(_frequencies).join(", ");
});

const switchToVestingNetwork = async (_id) => {
  _toast({
    id: "switch_network",
    title: "Confirm in Wallet",
    description: "Please confirm the network switch in your wallet",
    timeout: 5000,
  });

  try {
    await switchChain($wagmiConfig, { chainId: _id });
    multiClaimList.value = [];

    _toast({
      id: "switch_network_success",
      title: `Switched to ${getNetworkName(_id)}`,
      description: `You've successfully switched to ${getNetworkName(_id)}. You can now claim!`,
      timeout: 5000,
    });
  } catch (e) {
    _toast({
      id: "switch_network_failed",
      title: `Failed to switch to ${getNetworkName(_id)}`,
      description: `Does your wallet have the network?`,
      timeout: 5000,
    });
  }
};

const estimateETHFee = async (claim) => {
  console.log('claim', claim)
  try {
    const _fee = await readContract($wagmiConfig, {
      abi: [
        {
          inputs: [],
          name: "getCurrentFee",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
      ],
      address: claim.contract_address,
      functionName: "getCurrentFee",
      chain: claim.chain,
    });

    const etherFee = Number(_fee);
    let scaleFactor = 100000;
    if(claim.chain === 137) {
      scaleFactor = 10
    }
    const roundedNumber = Math.ceil(etherFee / 1e18 * scaleFactor) / scaleFactor * 1e18;
    console.log("roundedNumber", roundedNumber, Math.floor(roundedNumber) ,etherFee)
    // return etherFee;
    return Math.floor(roundedNumber)
  } catch (error) {
    console.log(error);
    return 0.005;
  }
};

const performClaim = async (claim) => {
  console.log("performClaim", claim)
  userStore.pauseUI = true;

  const _main = async (claim) => {
    try {
      /// Do early fail checks

      // if (claim.now_claimable_token <= 0) return;

      let requiredEthFee = 0;

      // if (claim?.has_fee && (claim.chain == 56 || claim.chain == 1 || claim.chain == 8453 || claim.chain == 97)) {
      if (claim?.has_fee) {
        let _balance = await getBalance($wagmiConfig, {
          chainId: claim.chain,
          address: address.value,
        });

        // console.log(_balance);

        requiredEthFee = await estimateETHFee(claim);

        console.log(requiredEthFee, Number(_balance.value), Number(_balance) < (requiredEthFee/1e18));

        if (Number(_balance.value) < requiredEthFee / 1e18) {
          // console.log("not enough eth");
          // throw new Error({
          //   shortMessage: "Not enough ETH to claim"
          // });
          _toast({
            id: "claim_error",
            title: "Error",
            description: "Not enough gas fee to claim",
            timeout: 5000,
          });
          return;
        }
      }

      /// At this point, all conditions should matched
      let _claim = null;
      if (claim?.has_merkletree) {

        _claim = await writeContract($wagmiConfig, {
          abi: [
            {
              "inputs": [
                {
                  "internalType": "uint256",
                  "name": "_allocation",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "_refund",
                  "type": "uint256"
                },
                {
                  "internalType": "bytes32[]",
                  "name": "_merkleProof",
                  "type": "bytes32[]"
                }
              ],
              "name": "claim",
              "outputs": [],
              "stateMutability": "payable",
              "type": "function"
            },
          ],
          address: claim.contract_address,
          functionName: "claim",
          args: [
            claim.whitelist.token_claimable_amount,
            claim.whitelist.stable_refundable_amount,
            JSON.parse(claim.whitelist.leaf),
          ],
          value: String(requiredEthFee),
        });

      } else {

        _claim = await writeContract($wagmiConfig, {
          abi: [
            {
              inputs: [],
              name: "claim",
              outputs: [],
              stateMutability: "payable",
              type: "function",
            },
          ],
          address: claim.contract_address,
          functionName: "claim",
          args: [],
          value: String(requiredEthFee),
        });

      }

      // console.log(_claim);

      if (_claim) {
        let claimReceipt = await waitForTransactionReceipt($wagmiConfig, {
          hash: _claim,
          confirmations: 2,
        });

        // console.log(claimReceipt)

        _toast({
          id: "claim",
          title: "Claimed!",
          description: "Your claim has been successful.",
          timeout: 5000,
        });
      }
    } catch (e) {
      console.log(e);
      _toast({
        id: "claim",
        title: "Error",
        description: `${e.shortMessage}`,
        timeout: 5000,
      });
    }
  };

  await _main(claim);
  // fetchRefundData();
  // emit("update");

  userStore.pauseUI = false;

  // emit("focus", entry.value.project.project_id);
};

const claimButton = async (_claim) => {
  await performClaim({
    ..._claim,
    contract_address: _claim.contract_address,
    chain: _claim.chainId,
    has_fee: _claim.has_fee,
  });
};

const isShowRefundModal = ref(false);

const showRefundModal = () => {
  isShowRefundModal.value = true;
};

onMounted(() => {
  watch(currentFocus, () => {
    if (id.value != currentFocus.value) {
      expand.value = false;
    }
  });
  watch(entry, () => {
    // everytime entry changed, we call the update amount function

    updateVesting();
  });
});



const multiClaimList = ref([]);
const addToMultiClaim = async (_claim) => {
  // console.log('addToMultiClaim', _claim)

  // list should not more than 10
  if( multiClaimList.value.length > 10 ) return;

  // added vesting cannot be pushed
  if( multiClaimList.value.map(x => x.contract_address).includes(_claim.contract_address) ) {
    multiClaimList.value = multiClaimList.value.filter(x => x.contract_address != _claim.contract_address);
  } else {
    const requiredEthFee = await estimateETHFee(_claim);
    const vesting = new ethers.Contract(_claim.contract_address, [
      "function multiClaim(address _account, uint _allocation, uint _refund, bytes32[] calldata _merkleProof) external"
    ])
    const pdata = await vesting.multiClaim.populateTransaction(
      $address.value,
      _claim.whitelist.token_claimable_amount,
      _claim.whitelist.stable_refundable_amount,
      JSON.parse(_claim.whitelist.leaf),
      {value:requiredEthFee}
    )
    multiClaimList.value.push({
      ..._claim,
      project: entry.value.project,
      calldata: pdata
    })
  }

  emit("multiclaim", { 
    "vesting": multiClaimList.value
  })

}


import { useEventBus } from '@vueuse/core'
const busMC = useEventBus('resetMulticlaim')
function listener(event) {
  // console.log('event', event);
  if(event) multiClaimList.value = []
}
const unsubMC = busMC.on(listener);


const isAllProjectVestingAdded = computed(() => {
  let all_checked = true;
  if(multiClaimList.value.length == 0) all_checked = false;
  for(let v of vestingRows.value) {
    if(v?.chainId == chainId.value && v?.has_multicall && v?.available_amount > 0) {
      if(!multiClaimList.value.map(x => x.contract_address).includes(v.contract_address)) all_checked = false;
    }
  }
  return all_checked;
})

const isAtLeastOneMultiClaim = computed(() => {
  for(let v of vestingRows.value) {
    if(v?.chainId == chainId.value && v?.has_multicall && v?.available_amount > 0) return true;
  }
})

const addProjectToMultiClaim = () => {
  for(let v of vestingRows.value) {
    if(v?.chainId == chainId.value && v?.has_multicall && v?.available_amount > 0) {
      addToMultiClaim(v);
    }
  }
}

</script>

<style></style>
